<template>
  <div>
    <div class="page-header">
      <h3>{{  $t('contacts.singular') }} Journal</h3>
    </div>

    <JournalFilter />

    <span v-for="contact in allContacts" v-if="contactTasks(contact.id).length">
      <h4  class="mt-4">{{contact.name}}</h4>
      <ul class="mt-2 list-group">
        <li v-for="task in contactTasks(contact.id)" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
          <QuickTask :task="task"/>
        </li>
      </ul>
    </span>
  </div>
</template>

<script>
import api from "api";
import QuickTask from "components/QuickTask";
import JournalFilter from "components/JournalFilter";

export default {
  components: {
    QuickTask,
    JournalFilter
  },
  computed: {
    allContacts: {
      get() {
          return this.$store.state.active_contacts
      }
    }
  },
  methods: {
    contactTasks: function(contact_id){
      return this.$store.state.tasks.filter(function (task){
        return (task.formatted_contact_list.includes(contact_id) && (task.completed === true && task.journaled === true))
      })
      .sort(function(a, b) {
        return new Date(b.completed_at) - new Date(a.completed_at);
      });
    }
  }
};
</script>
